import defaultHeaders from "../apiConfig";
import { callService, callServiceEmail } from "../apiService";

export async function recoverPasswordService(payload) {
  try {
    let request = {
      url: '/services/public/recoverPassword',
      method: 'POST',
      headers: defaultHeaders,
    };
    request.headers.Authorization = payload.authorization;
    request.body = payload;
    const { error, response } = await callServiceEmail(request);
    if (!error) {
      return { response };
    } else {
      return { error, response };
    }
  } catch (error) {
    return { error };
  }
}
